<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="d7e476">
<h1 class="chapno">
<a id="c1">
<h2 class="chapttl" id="d7e477">Acknowledgments</h2>
<p class="tx1" id="d7e479"><b><i>B</i></b>eing a busy stay-at-home mom, I found it an enormous challenge to write a book (it's hard enough just finding the time to even read one). But, thanks to some incredible people, the task was completed and a dream was fulfilled. Because of this, I want to take a moment to thank them.</p>
<p class="tx1" id="d7e483">First and foremost, thank you to my wonderful husband, Jeff. There would never have even been a book without your overwhelming love, incredible support, and fertile reproductive system.</p>
<p class="tx1" id="d7e485">To my editor, Kate Epstein, I'm forever grateful that you pulled my proposal out from your towering slush pile, and took a chance with it and me. This book is much better thanks to your creative ideas.</p>
<p class="tx1" id="d7e487">To Dr. Sandy Tisherman. I'm so glad that you agreed to share your medical advice and pregnancy secrets. You're an amazing doctor and approve so many more medications than I was allowed, that I almost wish that I were pregnant again. Almost.</p>
<p class="tx1" id="d7e489">And thanks to my mom for taking my daughter out every Wednesday so that I could work, even when she was cranky (my daughter, not my mom). Without your help, I'd still be on the table of contents.</p>
<p class="tx1" id="d7e491">And thanks to my dad, for telling me as a child that I had talent to write. It makes it easier to believe in yourself when someone you love believes in you first.</p>
<p class="tx1" id="d7e493">I'm also indebted to Nurse Sharron, my family, friends, and even complete strangers, who generously contributed their advice and pregnancy suckage stories for all to share and enjoy.</p>
<p class="tx1" id="d7e495">And finally, a big thanks to Po, my daughter's favorite Teletubbie, for keeping her entertained while Mommy had a deadline.</p>
</a></h1></div><a id="c1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Kime_9781440501951_epub_c1.vue?0a5315be